/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BranchType } from '../models/BranchType';
import type { RepairOrderQuoteStatusEnum } from '../models/RepairOrderQuoteStatusEnum';
import type { SortTypeEnum } from '../models/SortTypeEnum';
import type { VHCRecordCheckBrakeItemInput } from '../models/VHCRecordCheckBrakeItemInput';
import type { VHCRecordCheckItemInput } from '../models/VHCRecordCheckItemInput';
import type { VHCRecordCheckWheelTyreItemInput } from '../models/VHCRecordCheckWheelTyreItemInput';
import type { VHCRecordLabourInput } from '../models/VHCRecordLabourInput';
import type { VHCRecordLabourTotalDto } from '../models/VHCRecordLabourTotalDto';
import type { VHCRecordLogDto } from '../models/VHCRecordLogDto';
import type { VHCRecordLogInput } from '../models/VHCRecordLogInput';
import type { VHCRecordLogTableDtoPagedListData } from '../models/VHCRecordLogTableDtoPagedListData';
import type { VHCRecordPartInput } from '../models/VHCRecordPartInput';
import type { VHCRecordPartRequestDTO } from '../models/VHCRecordPartRequestDTO';
import type { VHCRecordPartTotalDto } from '../models/VHCRecordPartTotalDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class VhcRecordLogService {

  /**
   * Get table data
   * @param from 
   * @param to 
   * @param soHeaderId 
   * @param wipNo 
   * @param regNo 
   * @param quoteStatus 
   * @param branch
 *
 * 1 = Slough
 *
 * 2 = HighWycombe
 *
 * 3 = Maidenhead
 *
 * 4 = Watford
 *
 * 6 = HemelHempstead
 *
 * 7 = Romford
   * @param paginationSkipPagination Пропустить пагинацию
   * @param paginationPage Страница
   * @param paginationMaxCount Максимально количество записей на странице
   * @param repairOrderQuoteStatus
 *
 * 0 = Created
 *
 * 1 = Authorised
 *
 * 2 = Sent
 *
 * 3 = Confirmed
 *
 * 4 = Declined
 *
 * 5 = Cancelled
 *
 * 6 = Differed
   * @param sort 
   * @param order
 *
 * 0 = ASC
 *
 * 1 = DESC
   * @returns VHCRecordLogTableDtoPagedListData Success
   * @throws ApiError
   */
  public static getVhcRecords(
from?: string,
to?: string,
soHeaderId?: number,
wipNo?: string,
regNo?: string,
quoteStatus?: number,
branch?: BranchType,
paginationSkipPagination?: boolean,
paginationPage?: number,
paginationMaxCount?: number,
repairOrderQuoteStatus?: RepairOrderQuoteStatusEnum,
sort?: string,
order?: SortTypeEnum,
): CancelablePromise<VHCRecordLogTableDtoPagedListData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/vhc-records',
      query: {
        'From': from,
        'To': to,
        'SoHeaderId': soHeaderId,
        'WipNo': wipNo,
        'RegNo': regNo,
        'QuoteStatus': quoteStatus,
        'Branch': branch,
        'Pagination.SkipPagination': paginationSkipPagination,
        'Pagination.Page': paginationPage,
        'Pagination.MaxCount': paginationMaxCount,
        'RepairOrderQuoteStatus': repairOrderQuoteStatus,
        'Sort': sort,
        'Order': order,
      },
    });
  }

  /**
   * Create VHC Record
   * @param requestBody 
   * @returns number Created
   * @throws ApiError
   */
  public static postVhcRecords(
requestBody?: VHCRecordLogInput,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/vhc-records',
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * Get details
   * @param id 
   * @returns VHCRecordLogDto Success
   * @throws ApiError
   */
  public static getVhcRecords1(
id: number,
): CancelablePromise<VHCRecordLogDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/vhc-records/{id}',
      path: {
        'id': id,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * Update VHC Record
   * @param id 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putVhcRecords(
id: number,
requestBody?: VHCRecordLogInput,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/vhc-records/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * Delete VHC Record
   * @param id 
   * @returns any Success
   * @throws ApiError
   */
  public static deleteVhcRecords(
id: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/vhc-records/{id}',
      path: {
        'id': id,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * Get all labours
   * @param id 
   * @returns VHCRecordLabourTotalDto Success
   * @throws ApiError
   */
  public static getVhcRecordsLabours(
id: number,
): CancelablePromise<VHCRecordLabourTotalDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/vhc-records/{id}/labours',
      path: {
        'id': id,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * Get all parts
   * @param id 
   * @returns VHCRecordPartTotalDto Success
   * @throws ApiError
   */
  public static getVhcRecordsParts(
id: number,
): CancelablePromise<VHCRecordPartTotalDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/vhc-records/{id}/parts',
      path: {
        'id': id,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * Create part request
   * @param id 
   * @returns VHCRecordPartRequestDTO Created
   * @throws ApiError
   */
  public static postVhcRecordsPartRequests(
id: number,
): CancelablePromise<Array<VHCRecordPartRequestDTO>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/vhc-records/{id}/part-requests',
      path: {
        'id': id,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * Create repair order quote for VHC, include labours and parts
   * @param id VHC Record Id
   * @param userId Id of User, who create quote
   * @returns boolean Created
   * @throws ApiError
   */
  public static postVhcRecordsRepairOrderQuote(
id: number,
userId?: number,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/vhc-records/{id}/repair-order-quote',
      path: {
        'id': id,
      },
      query: {
        'userId': userId,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * Update existing repair order quote for VHC, creating new labours and parts lines for quote
   * @param id VHC Record Id
   * @returns boolean Success
   * @throws ApiError
   */
  public static putVhcRecordsRepairOrderQuote(
id: number,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/vhc-records/{id}/repair-order-quote',
      path: {
        'id': id,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @returns any Success
   * @throws ApiError
   */
  public static postVhcRecordsAuthorizationEmail(
id: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/vhc-records/{id}/authorization-email',
      path: {
        'id': id,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @returns any Success
   * @throws ApiError
   */
  public static postVhcRecordsReportEmail(
id: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/vhc-records/{id}/report-email',
      path: {
        'id': id,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * Upload Video
   * @param id 
   * @param formData 
   * @returns string Created
   * @throws ApiError
   */
  public static postVhcRecordsVideos(
id: number,
formData?: {
Video: Blob;
},
): CancelablePromise<string> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/vhc-records/{id}/videos',
      path: {
        'id': id,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * Remove Video
   * @param id 
   * @returns any Success
   * @throws ApiError
   */
  public static deleteVhcRecordsVideos(
id: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/vhc-records/{id}/videos',
      path: {
        'id': id,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * Create Check Item
   * @param logId 
   * @param requestBody 
   * @returns number Created
   * @throws ApiError
   */
  public static postVhcRecordsItemsChecks(
logId: number,
requestBody?: VHCRecordCheckItemInput,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/vhc-records/{logId}/items/checks',
      path: {
        'logId': logId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * Update Check Item
   * @param logId 
   * @param itemId 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putVhcRecordsItemsChecks(
logId: number,
itemId: number,
requestBody?: VHCRecordCheckItemInput,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/vhc-records/{logId}/items/checks/{itemId}',
      path: {
        'logId': logId,
        'itemId': itemId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * Delete Check Item
   * @param logId 
   * @param itemId 
   * @returns any Success
   * @throws ApiError
   */
  public static deleteVhcRecordsItemsChecks(
logId: number,
itemId: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/vhc-records/{logId}/items/checks/{itemId}',
      path: {
        'logId': logId,
        'itemId': itemId,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param logId 
   * @param itemId 
   * @param requestBody 
   * @returns number Created
   * @throws ApiError
   */
  public static postVhcRecordsItemsChecksLabours(
logId: number,
itemId: number,
requestBody?: VHCRecordLabourInput,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/vhc-records/{logId}/items/checks/{itemId}/labours',
      path: {
        'logId': logId,
        'itemId': itemId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param logId 
   * @param itemId 
   * @param labourId 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putVhcRecordsItemsChecksLabours(
logId: number,
itemId: number,
labourId: number,
requestBody?: VHCRecordLabourInput,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/vhc-records/{logId}/items/checks/{itemId}/labours/{labourId}',
      path: {
        'logId': logId,
        'itemId': itemId,
        'labourId': labourId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param logId 
   * @param itemId 
   * @param labourId 
   * @returns any Success
   * @throws ApiError
   */
  public static deleteVhcRecordsItemsChecksLabours(
logId: number,
itemId: number,
labourId: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/vhc-records/{logId}/items/checks/{itemId}/labours/{labourId}',
      path: {
        'logId': logId,
        'itemId': itemId,
        'labourId': labourId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param logId 
   * @param itemId 
   * @param requestBody 
   * @returns number Created
   * @throws ApiError
   */
  public static postVhcRecordsItemsChecksParts(
logId: number,
itemId: number,
requestBody?: VHCRecordPartInput,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/vhc-records/{logId}/items/checks/{itemId}/parts',
      path: {
        'logId': logId,
        'itemId': itemId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param logId 
   * @param itemId 
   * @param partId 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putVhcRecordsItemsChecksParts(
logId: number,
itemId: number,
partId: number,
requestBody?: VHCRecordPartInput,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/vhc-records/{logId}/items/checks/{itemId}/parts/{partId}',
      path: {
        'logId': logId,
        'itemId': itemId,
        'partId': partId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param logId 
   * @param itemId 
   * @param partId 
   * @returns any Success
   * @throws ApiError
   */
  public static deleteVhcRecordsItemsChecksParts(
logId: number,
itemId: number,
partId: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/vhc-records/{logId}/items/checks/{itemId}/parts/{partId}',
      path: {
        'logId': logId,
        'itemId': itemId,
        'partId': partId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * Create Check Brake Item
   * @param logId 
   * @param requestBody 
   * @returns number Created
   * @throws ApiError
   */
  public static postVhcRecordsItemsBrakes(
logId: number,
requestBody?: VHCRecordCheckBrakeItemInput,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/vhc-records/{logId}/items/brakes',
      path: {
        'logId': logId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * Update Check Brake Item
   * @param logId 
   * @param itemId 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putVhcRecordsItemsBrakes(
logId: number,
itemId: number,
requestBody?: VHCRecordCheckBrakeItemInput,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/vhc-records/{logId}/items/brakes/{itemId}',
      path: {
        'logId': logId,
        'itemId': itemId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * Delete Check Brake Item
   * @param logId 
   * @param itemId 
   * @returns any Success
   * @throws ApiError
   */
  public static deleteVhcRecordsItemsBrakes(
logId: number,
itemId: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/vhc-records/{logId}/items/brakes/{itemId}',
      path: {
        'logId': logId,
        'itemId': itemId,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param logId 
   * @param itemId 
   * @param requestBody 
   * @returns number Created
   * @throws ApiError
   */
  public static postVhcRecordsItemsBrakesLabours(
logId: number,
itemId: number,
requestBody?: VHCRecordLabourInput,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/vhc-records/{logId}/items/brakes/{itemId}/labours',
      path: {
        'logId': logId,
        'itemId': itemId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param logId 
   * @param itemId 
   * @param labourId 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putVhcRecordsItemsBrakesLabours(
logId: number,
itemId: number,
labourId: number,
requestBody?: VHCRecordLabourInput,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/vhc-records/{logId}/items/brakes/{itemId}/labours/{labourId}',
      path: {
        'logId': logId,
        'itemId': itemId,
        'labourId': labourId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param logId 
   * @param itemId 
   * @param labourId 
   * @returns any Success
   * @throws ApiError
   */
  public static deleteVhcRecordsItemsBrakesLabours(
logId: number,
itemId: number,
labourId: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/vhc-records/{logId}/items/brakes/{itemId}/labours/{labourId}',
      path: {
        'logId': logId,
        'itemId': itemId,
        'labourId': labourId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param logId 
   * @param itemId 
   * @param requestBody 
   * @returns number Created
   * @throws ApiError
   */
  public static postVhcRecordsItemsBrakesParts(
logId: number,
itemId: number,
requestBody?: VHCRecordPartInput,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/vhc-records/{logId}/items/brakes/{itemId}/parts',
      path: {
        'logId': logId,
        'itemId': itemId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param logId 
   * @param itemId 
   * @param partId 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putVhcRecordsItemsBrakesParts(
logId: number,
itemId: number,
partId: number,
requestBody?: VHCRecordPartInput,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/vhc-records/{logId}/items/brakes/{itemId}/parts/{partId}',
      path: {
        'logId': logId,
        'itemId': itemId,
        'partId': partId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param logId 
   * @param itemId 
   * @param partId 
   * @returns any Success
   * @throws ApiError
   */
  public static deleteVhcRecordsItemsBrakesParts(
logId: number,
itemId: number,
partId: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/vhc-records/{logId}/items/brakes/{itemId}/parts/{partId}',
      path: {
        'logId': logId,
        'itemId': itemId,
        'partId': partId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * Create Check Wheel Tyre Item
   * @param logId 
   * @param requestBody 
   * @returns number Created
   * @throws ApiError
   */
  public static postVhcRecordsWheelTyresCheck(
logId: number,
requestBody?: VHCRecordCheckWheelTyreItemInput,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/vhc-records/{logId}/wheel-tyres/check',
      path: {
        'logId': logId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * Update Check Wheel Tyre Item
   * @param logId 
   * @param itemId 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putVhcRecordsItemsWheelTyres(
logId: number,
itemId: number,
requestBody?: VHCRecordCheckWheelTyreItemInput,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/vhc-records/{logId}/items/wheel-tyres/{itemId}',
      path: {
        'logId': logId,
        'itemId': itemId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * Delete Check Wheel Tyre Item
   * @param logId 
   * @param itemId 
   * @returns any Success
   * @throws ApiError
   */
  public static deleteVhcRecordsItemsWheelTyres(
logId: number,
itemId: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/vhc-records/{logId}/items/wheel-tyres/{itemId}',
      path: {
        'logId': logId,
        'itemId': itemId,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param logId 
   * @param itemId 
   * @param requestBody 
   * @returns number Created
   * @throws ApiError
   */
  public static postVhcRecordsItemsWheelTyresLabours(
logId: number,
itemId: number,
requestBody?: VHCRecordLabourInput,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/vhc-records/{logId}/items/wheel-tyres/{itemId}/labours',
      path: {
        'logId': logId,
        'itemId': itemId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param logId 
   * @param itemId 
   * @param labourId 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putVhcRecordsItemsWheelTyresLabours(
logId: number,
itemId: number,
labourId: number,
requestBody?: VHCRecordLabourInput,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/vhc-records/{logId}/items/wheel-tyres/{itemId}/labours/{labourId}',
      path: {
        'logId': logId,
        'itemId': itemId,
        'labourId': labourId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param logId 
   * @param itemId 
   * @param labourId 
   * @returns any Success
   * @throws ApiError
   */
  public static deleteVhcRecordsItemsWheelTyresLabours(
logId: number,
itemId: number,
labourId: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/vhc-records/{logId}/items/wheel-tyres/{itemId}/labours/{labourId}',
      path: {
        'logId': logId,
        'itemId': itemId,
        'labourId': labourId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param logId 
   * @param itemId 
   * @param requestBody 
   * @returns number Created
   * @throws ApiError
   */
  public static postVhcRecordsItemsWheelTyresParts(
logId: number,
itemId: number,
requestBody?: VHCRecordPartInput,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/vhc-records/{logId}/items/wheel-tyres/{itemId}/parts',
      path: {
        'logId': logId,
        'itemId': itemId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param logId 
   * @param itemId 
   * @param partId 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putVhcRecordsItemsWheelTyresParts(
logId: number,
itemId: number,
partId: number,
requestBody?: VHCRecordPartInput,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/vhc-records/{logId}/items/wheel-tyres/{itemId}/parts/{partId}',
      path: {
        'logId': logId,
        'itemId': itemId,
        'partId': partId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param logId 
   * @param itemId 
   * @param partId 
   * @returns any Success
   * @throws ApiError
   */
  public static deleteVhcRecordsItemsWheelTyresParts(
logId: number,
itemId: number,
partId: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/vhc-records/{logId}/items/wheel-tyres/{itemId}/parts/{partId}',
      path: {
        'logId': logId,
        'itemId': itemId,
        'partId': partId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

}
